import {Navigate, Route} from "react-router";
import {PaymentTermsV2Layout} from "~/experiments/pages/payment-terms-v2/PaymentTermsV2Layout";
import {RequireAuth} from "~/authentication/routing/RequireAuth";
import {OverviewTab} from "~/experiments/pages/payment-terms-v2/tabs/OverviewTab";
import {LeakageTab} from "~/experiments/pages/payment-terms-v2/tabs/LeakageTab";
import {HarmonizationTab} from "~/experiments/pages/payment-terms-v2/tabs/HarmonizationTab";
import {DiscountsTab} from "~/experiments/pages/payment-terms-v2/tabs/DiscountsTab";
import {ActionPlanTab} from "~/experiments/pages/payment-terms-v2/tabs/ActionPlanTab";
import {SourcesTab} from "~/experiments/pages/payment-terms-v2/tabs/SourcesTab";
import {PtV2SettingsPage} from "~/experiments/pages/payment-terms-v2/PtV2SettingsPage";
import {routes} from "~/routing/routes";

/** Payment Terms v2 (experimental): one layout, one URL per tab, defaulting to overview. */
export const paymentTermsV2Route = (
    <Route path={routes.payment_terms_v2} element={<RequireAuth><PaymentTermsV2Layout/></RequireAuth>}>
        <Route index element={<Navigate to="overview" replace/>}/>
        <Route path="overview" element={<OverviewTab/>}/>
        <Route path="leakage" element={<LeakageTab/>}/>
        <Route path="harmonization" element={<HarmonizationTab/>}/>
        <Route path="discounts" element={<DiscountsTab/>}/>
        <Route path="actions" element={<ActionPlanTab/>}/>
        <Route path="sources" element={<SourcesTab/>}/>
        <Route path="settings" element={<PtV2SettingsPage/>}/>
        <Route path="*" element={<Navigate to="../overview" replace/>}/>
    </Route>
);
